// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"d844d4b1","977":"37dbf0dc"}[chunkId] + ".chunk.js";
};